var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDragThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 3.83336H5.02563L5.02564 0.500031H7.99999L7.99999 3.83336ZM7.99999 9.1667H5.02563L5.02564 5.83336H7.99999L7.99999 9.1667ZM7.99999 14.5H5.02564L5.02565 11.1667H8L7.99999 14.5ZM3 3.83336H0L6.19887e-06 0.500031H3L3 3.83336ZM3 9.1667H0V5.83336H3V9.1667ZM2.99999 14.5H6.67571e-06L1.23977e-05 11.1667H3L2.99999 14.5Z",
    fill: "#76787F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragThree);
export default __webpack_public_path__ + "static/media/IconDragThree.10483064.svg";
export { ForwardRef as ReactComponent };